import React from 'react';

import {Container, FileContent, Name} from './styles';
import {IoCloseCircle, IoDocument} from 'react-icons/io5';
import {FileProps} from 'shared/types/file';

interface Props {
  file: File | FileProps;
  remove: () => void;
}

const SelectedFile: React.FC<Props> = ({file, remove}) => {
  const isFileProps = (object: any): object is FileProps => {
    return !!object.url;
  };

  return (
    <Container>
      <IoDocument size={22} />
      <FileContent
        onClick={() => isFileProps(file) && window.open(file.url, '_blank')}>
        <Name>{file.name ?? 'Anexo'}</Name>
        {/* <Size>{getFileSize(file)}</Size> */}
      </FileContent>
      <IoCloseCircle
        onClick={remove}
        size={22}
        color="white"
        style={{cursor: 'pointer'}}
      />
    </Container>
  );
};

export default SelectedFile;
